/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: () => ({
        swatchGroup: {
            flexDirection: 'column'
        },
        swatchLabel: {
            alignItems: 'flex-start'
        },
        swatch: {
            position: 'relative',
            backgroundColor: 'white',
            _focus: {
                outline: 'none',
                boxShadow: 'outline'
            }
        },
        swatchButton: {
            borderColor: 'gray.200',
            _disabled: {
                opacity: 1
            }
        },
        swatchesWrapper: {
            pt: ['24px', '24px', '24px', '16px'],
            pb: ['18px', '18px', '18px', '15px']
        }
    }),
    variants: {
        color: (props) => ({
            swatch: {
                height: '26px',
                width: '26px',
                borderRadius: 'full',
                padding: 0,
                cursor: 'pointer',
                marginRight: 2,
                marginLeft: 0,
                minWidth: '26px',
                color: `${props.selected ? 'black' : 'gray.200'}`,
                border: `${props.selected ? '1px' : '0'}`,
                _hover: {
                    borderColor: `${props.selected ? 'black' : 'gray.200'}`,
                    borderWidth: 1,
                    borderStyle: 'solid'
                },
                _active: {
                    background: 'transparent'
                }
                // _before: {
                //     content: '""',
                //     display: `${props.disabled ? 'block' : 'none'}`,
                //     position: 'absolute',
                //     height: '26px',
                //     width: '1px',
                //     transform: 'rotate(45deg)',
                //     backgroundColor: '#00000038',
                //     zIndex: 1
                // }
            },
            swatchButton: {
                height: '100%',
                borderColor: 'gray.200',
                width: '100%',
                overflow: 'hidden',
                borderRadius: 'full',
                minWidth: 'auto',
                opacity: 1,
                _focus: {
                    outline: 'none'
                }
            }
        }),
        shade: (props) => ({
            swatch: {
                height: '26px',
                width: '26px',
                borderRadius: 'full',
                padding: 0,
                cursor: 'pointer',
                marginRight: 2,
                marginLeft: 0,
                minWidth: '26px',
                color: `${props.selected ? 'black' : 'gray.200'}`,
                border: `${props.selected ? '1px' : '0'}`,
                _hover: {
                    borderColor: `${props.selected ? 'black' : 'gray.200'}`,
                    borderWidth: 1,
                    borderStyle: 'solid'
                },
                _active: {
                    background: 'transparent'
                }
                // _before: {
                //     content: '""',
                //     display: `${props.disabled ? 'block' : 'none'}`,
                //     position: 'absolute',
                //     height: '26px',
                //     width: '1px',
                //     transform: 'rotate(45deg)',
                //     backgroundColor: '#00000038',
                //     zIndex: 1
                // }
            },
            swatchButton: {
                height: '100%',
                borderColor: 'gray.200',
                width: '100%',
                overflow: 'hidden',
                borderRadius: 'full',
                minWidth: 'auto',
                opacity: 1,
                _focus: {
                    outline: 'none'
                }
            }
        }),
        size: (props) => ({
            swatch: {
                // diagonal line for disabled options
                // theme variable like gray.200 won't work inside linear-gradient
                backgroundImage: `${
                    props.disabled
                        ? `${props.selected ? '#0000001F' : '#0000001F'} `
                        : ''
                }`,
                width: '101px',
                borderRadius: '34px',
                py: '6px',
                _focus: {outline: 'none'},
                _hover: {
                    textDecoration: 'none',
                    backgroundColor: 'gray.100'
                },
                backgroundColor: `${
                    props.selected
                        ? props.disabled
                            ? 'gray.100'
                            : '#F3F3F3'
                        : 'white'
                }`,
                color: `${
                    props.selected && !props.disabled ? 'black' : 'gray.900'
                }`,
                fontWeight: `${
                    props.selected && !props.disabled ? '500' : '400'
                }`
            },
            swatchButton: {}
        })
    },
    parts: ['swatch', 'swatchButton']
}
